import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { StarIcon, WifiIcon } from 'lucide-react';

const renderStars = (rating) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (i <= rating) {
      stars.push(<StarIcon key={i} size={14} className="text-yellow-500 fill-yellow-500" />);
    } else {
      stars.push(<StarIcon key={i} size={14} className="text-gray-300" />);
    }
  }
  return stars;
};

const TherapistCard = ({ therapist, onBookSession }) => {
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const navigate = useNavigate();

  const handleBookSession = () => {
    if (onBookSession) {
      onBookSession(therapist.id);
    } else {
      console.log(`Book session with ${therapist.username} (ID: ${therapist.id})`);
      // Default action if no onBookSession prop is provided
    }
  };

  const handleViewProfile = () => {
    navigate(`/client/therapist-profile/${therapist.id}`);
    console.log(`Viewing profile of ${therapist.username} (ID: ${therapist.id})`);
  };

  const handleReviewTherapist = () => {
    navigate(`/client/review-therapist/${therapist.id}`);
    console.log(`Reviewing therapist ${therapist.username} (ID: ${therapist.id})`);
  };

  return (
    <Card className="border rounded-xl shadow-sm mb-4">
      <CardContent className="p-4">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div>
            <p className="font-semibold text-gray-800 text-lg">{therapist.username}</p>
            <p className="text-sm text-gray-500">{therapist.tags || "No tags"}</p>
            <p className="text-xs mt-1 text-gray-400">Experience: {therapist.experience || "N/A"}</p>
            <div className="flex items-center gap-2 text-xs text-gray-400">
              {therapist.is_online ? (
                <span className="flex items-center text-green-500"><WifiIcon size={12} className="mr-1" /> Online Now</span>
              ) : (
                <span className="flex items-center text-red-500"><WifiIcon size={12} className="mr-1" /> Offline</span>
              )}
            </div>
            <p className="text-xs mt-2 text-gray-400 font-semibold">Recurring Availability:</p>
            {therapist.availabilities && therapist.availabilities.length > 0 ? (
              therapist.availabilities.map((avail, index) => (
                <p key={index} className="text-xs text-gray-400">
                  {daysOfWeek[avail.day_of_week]}: {avail.start_time} - {avail.end_time}
                </p>
              ))
            ) : (
              <p className="text-xs text-gray-400">No recurring availability set.</p>
            )}
          </div>
          <div className="flex items-center gap-2 text-yellow-500 text-sm">
            {renderStars(therapist.average_rating)}
            <span className="text-gray-700 font-medium">{(therapist.average_rating || 0).toFixed(1)}</span>
          </div>
        </div>

        <div className="mt-4 flex gap-3 flex-wrap">
          <Button onClick={handleBookSession}>Book Session</Button>
          <Button variant="outline" onClick={handleViewProfile}>View profile</Button>
          <Button variant="outline" onClick={handleReviewTherapist}>Review</Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default TherapistCard;
